import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Switch } from 'components/shared';
import { theme } from 'styles';

const propTypes = {
  recurring: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

const StyledRecurringToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  transition: color 0.3s;
  line-height: 18px;
  color: ${props => (props.recurring ? theme.colors.navy : theme.colors.grey)};
  font-size: 14px;

  ${props =>
    props.dark &&
    `
    button {
      color: ${theme.colors.white};
    }

    .AddToCart__RecurringToggleSwitch span {
      background-color: ${theme.colors.blue};
    }
  `};
`;

// Why does this work?????
function RecurringToggle(props) {
  const { recurring, onChange } = props;
  return (
    <StyledRecurringToggle recurring={recurring} {...props}>
      <button onClick={onChange} className="AddToCart__RecurringToggleLabel">
        Monthly Auto Renew
      </button>

      <div className="AddToCart__RecurringToggleSwitch">
        <Switch name="recurring" isChecked={recurring} onToggle={onChange} />
      </div>
    </StyledRecurringToggle>
  );
}

RecurringToggle.propTypes = propTypes;

export default RecurringToggle;



// WEBPACK FOOTER //
// ./src/components/shared/UpdateCartItem/RecurringToggle.jsx